module.exports = "<div class=\"side-menu\" [ngClass]=\"{ 'expand': expand }\">\n    <menu-item *ngFor=\"let menu of userModules; let i = index\" [name]=\"menu.name\" [item]=\"menu\" [expand]=\"expand\" [index]=\"i\"></menu-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/side-menu/side-menu.component.html
// module id = 1839
// module chunks = 0